import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { UiModule } from '@collab/comp-library';
import { environment } from 'src/environments/environment';
import { CarouselComponent } from '../component/carousel/carousel.component';
import { ImgGeneratorComponent } from '../component/img-generator/img-generator.component';
import { TabNavigatorComponent } from '../component/tab-navigator/tab-navigator.component';
import { VideoContainerComponent } from '../component/video-container/video-container.component';
import { VideoComponent } from '../component/video/video.component';
import { TrapFocusDirective } from '../directive/trap-focus.directive';
import {AllProductsCardComponent} from "../component/all-products-card/all-products-card.component";
import { TermsPolicyComponent } from '../terms-policy/terms-policy.component';


@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        UiModule.forRoot({
            configuration: {env: environment}
        }),
    ],
    declarations: [
        TabNavigatorComponent,
        ImgGeneratorComponent,
        AllProductsCardComponent,
        TrapFocusDirective,
        VideoComponent,
        VideoContainerComponent,
        CarouselComponent,
        TermsPolicyComponent
    ],
    providers: [
    ],
    exports: [
        FormsModule,
        ReactiveFormsModule,
        TabNavigatorComponent,
        ImgGeneratorComponent,
        AllProductsCardComponent,
        TrapFocusDirective,
        CommonModule,
        VideoComponent,
        UiModule,
        VideoContainerComponent,
        CarouselComponent,
        TermsPolicyComponent
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class SharedComponentsModule {

    constructor() {
    }
}
